module.exports = __webpack_public_path__ + "static/media/Gaelic-Labs.b9b6162a.png";